import React from "react";
import { getPublicFolderPath } from "../../../utils";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  img: { marginRight: theme.spacing(1.5) },
  text: {
    fontWeight: 400,
  },
  header: {
    fontWeight: 700,
  },
  message: {
    fontSize: ({ header }: any) => {
      return header ? 12 : "default";
    },
  },
  actions: {
    marginLeft: "auto",
    paddingLeft: theme.spacing(0.5),
  },
}));

function getIconBasedOnType(type: string) {
  let icon = null;
  if (type === "error") {
    icon = "icons/snackbar/error.svg";
  }
  if (type === "delete") {
    icon = "icons/snackbar/delete.svg";
  }
  if (type === "success") {
    icon = "icons/snackbar/success.svg";
  }
  return icon;
}

export default function SnackbarContent({
  header,
  message,
  type,
  handleClose,
}) {
  const classes = useStyles({ header });

  let icon = null;
  if (type) {
    icon = getIconBasedOnType(type);
  }

  return (
    <div className={classes.container}>
      {icon && (
        <img
          src={getPublicFolderPath(window.location.pathname) + icon}
          alt=""
          className={classes.img}
        />
      )}
      <div className={classes.text}>
        <Typography variant="body2" className={classes.header}>
          {header}
        </Typography>
        <Typography variant="body2" className={classes.message}>
          {message}
        </Typography>
      </div>
      <div className={classes.actions}>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
}
